import {createStyles, WithStyles} from '@material-ui/core';
import {Theme} from 'feedback-system/with-root/typedef';

export const styles = (theme: Theme) => createStyles({
    modal: {
        padding: '0 15px',
        borderRadius: '8px',
        margin: '48px 10px',
        [theme.breakpoints.down('sm')]: {
            maxHeight: 'none',
            margin: '48px 7px'
        }
    },
    content: {
        padding: '24px 0',
        [theme.breakpoints.down('sm')]: {
            padding: '12px 0 !important'
        }
    },
    contentText: {
        display: 'flex',
        alignItems: 'center',
        color: theme.palette.primary.main
    },
    icon: {
        marginRight: '10px'
    }
});

export type Classes = WithStyles<typeof styles>
